import { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketAccounts = ({ dispatch }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();



  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handleAccounts = (data) => {
        if ((data.action === "update") && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          dispatch({ type: "UPDATE_CLIENTS", payload: data.account });
        }
      };

      socket.on("management", handleAccounts);

      return () => {
        socket.off("management", handleAccounts);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);



  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketAccounts;
